import { useState, useLayoutEffect, useEffect } from 'react';
import {
  MediumHeightDivider,
  SmallHeightDivider,
  StyledButtonOutlined,
  Title
} from '../../theme/Styles';
import { useDispatch } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import {
  ButtonsMenuContainer,
  Container,
  HeaderSection
} from './styles/GeneralQueriesStyles';
import { generalQueriesDocumentsMockup, generalQueriesMapsMockup, menuOptions } from './GeneralQueriesConstants';
import { ButtonGroup, Grid } from '@mui/material';
import { useQuery } from 'react-query'
import MapCard from './components/MapCard/MapCard';
import Select from '../../components/Select/Select';
import TextField from '../../components/TextField/TextField';
import FilePDF from './components/FilePDF/FilePDF';
import { getDocumentsFromWordpress, getMapsDataFromWordpress } from '../../api/GeneralQueries';
import CenterLoading from '../../components/CenterLoading/CenterLoading';

function GeneralQueries() {

  const dispatch = useDispatch();

  const { data:mapsData, isLoading:mapsLoading } = useQuery(['mapsData'], () => getMapsDataFromWordpress())

  useLayoutEffect(() => {
    dispatch(UpdateAppSubHeaderTitle('Consultas generales')); // TITLE OF SUBHEADER APP
  }, [dispatch]);

  if (mapsLoading) return <CenterLoading/>

  return (
    <Container>
      <HeaderSection sx={{ mb: 4, textAlign: 'center' }}>
          <Title>Mapa de los Polos</Title>
      </HeaderSection>

      <Grid
        alignItems='center'
        justifyContent='flex-start'
        container
        direction='row'
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        {
          mapsData?.map((item, index) => (
            <Grid item xs={4} sm={4} md={4} key={index}>
              <MapCard {...item} />
            </Grid>
          ))
        }
      </Grid>
      <MediumHeightDivider />
    </Container>
  );
}

export default GeneralQueries;
